import { Box, Typography, Paper } from '@mui/material'
import React from 'react'
import { isolateNumber } from '@/utils/numberDirection'

type CustomTooltipProps = {
  active?: boolean
  payload?: any[]
  label?: string | number
  currName: string
  prevName: string
  isDarkMode?: boolean
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, isDarkMode = false }) => {
  if (!active || !payload || payload.length === 0) return null

  const bgColor = isDarkMode ? '#183254ff' : '#326580'

  return (
    <Paper
      elevation={3}
      sx={{
        backgroundColor: bgColor,
        padding: '5px',
      }}
    >
      {payload.map((entry, index) => (
        <Box
          key={`tooltip-${index}`}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: entry.color,
              mr: 1,
            }}
          />
          <Typography
            sx={{
              fontSize: 13,
              color: '#EFF2F7',
              marginRight: '2px',
              fontFamily: 'Rubik, sans-serif',
            }}
          >
            ק׳
          </Typography>
          <Typography
            sx={{
              fontSize: 13,
              color: '#EFF2F7',
              fontFamily: 'Rubik, sans-serif',
            }}
          >
            {isolateNumber(entry.value)}
          </Typography>
        </Box>
      ))}
    </Paper>
  )
}

export default CustomTooltip
